import { createFileRoute } from "@tanstack/react-router";

import { AthleteQuestionnaireSubmissionFillPage } from "src/pages/AthleteQuestionnaireSubmissionFillPage";

export const Route = createFileRoute(
  "/_auth/_athlete/questionnaire-submissions/$submissionId/",
)({
  component: AthleteQuestionnaireSubmissionFillPage,
  ssr: true,
});
